

export class VehicleTypeStatusInput implements IVehicleTypeStatusInput {
    /** The auto-generated id of the vehicle type master */
    vehicleTypeId!: number;
    /** The updated status */
    status!: number;

    constructor(data?: IVehicleTypeStatusInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehicleTypeId = _data["vehicleTypeId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): VehicleTypeStatusInput {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleTypeStatusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vehicleTypeId"] = this.vehicleTypeId;
        data["status"] = this.status;
        return data; 
    }
}

export interface IVehicleTypeStatusInput {
    /** The auto-generated id of the vehicle type master */
    vehicleTypeId: number;
    /** The updated status */
    status: number;
}

